<template>
  <section id="testimonials">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="title">
            <h3>Our Values &amp; Principles</h3>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="carouselButtons">
            <button
              id="playValues"
              type="button"
              class="btn btn-default btn-xs"
            >
              <span class="fa fa-play-circle-o"></span>
            </button>
            <button
              id="pauseValues"
              type="button"
              class="btn btn-default btn-xs"
            >
              <span class="fa fa-pause-circle-o"></span>
            </button>
          </div>
        </div>
      </div>
      <div
        id="fawesome-carousel-two"
        class="carousel slide"
        data-ride="carousel"
      >
        <ol class="carousel-indicators">
          <li
            data-target="#fawesome-carousel-two"
            data-slide-to="0"
            class="active"
          ></li>
          <li data-target="#fawesome-carousel-two" data-slide-to="1"></li>
          <li data-target="#fawesome-carousel-two" data-slide-to="2"></li>
        </ol>
        <!-- Slide 1 -->
        <div class="carousel-inner" role="listbox">
          <div class="item active">
            <div class="row">
              <div class="col-sm-6">
                <div class="single-testimonials">
                  <div class="text">
                    <p>
                      <b>Quality of life:</b>
                      People that we support should be treated with dignity and
                      respect. We strive to personalise care and, enabling the
                      person to achieve their hopes, goals, and aspirations. We
                      strive to maximise the person's quality of life regardless
                      of the nature of their disability or behaviours that
                      challenge. Our focus is on supporting people to live in
                      their own homes within the community.
                    </p>
                  </div>

                  <div class="profile-image">
                    <span class="fa fa-thumbs-o-up"></span>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="single-testimonials">
                  <div class="text">
                    <p>
                      <b>Keeping people safe:</b>
                      People should be supported to take positive risks whilst
                      ensuring that they are protected from potential harm,
                      remembering that abuse and neglect can take place in a
                      range of different environments and settings. There should
                      be a culture of transparent and open reporting, ensuring
                      lessons are learned and acted upon.
                    </p>
                  </div>

                  <div class="profile-image">
                    <span class="fa fa-thumbs-o-up"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Slide 2 -->
          <div class="item">
            <div class="row">
              <div class="col-sm-6">
                <div class="single-testimonials">
                  <div class="text">
                    <p>
                      <b>Equitable outcomes:</b>
                      We strive and advocate for equitable outcomes comparable
                      with the general population, by ensuring that mainstream
                      services are available to all people that we support, and
                      that reasonable adjustments are made where necessary, in
                      line with Equality Act legislation, with access to
                      specialist multi- disciplinary community-based health and
                      social care expertise as appropriate.
                    </p>
                  </div>

                  <div class="profile-image">
                    <span class="fa fa-thumbs-o-up"></span>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="single-testimonials">
                  <div class="text">
                    <p>
                      <b>A Person - Centred Approach:</b>
                      We place the person we support at the centre of the
                      service and treat them as a person first. The focus is on
                      the person and what they can do, not their condition or
                      disability. We focus on achieving the person's aspirations
                      and tailor these to their needs and unique circumstances.
                    </p>
                  </div>

                  <div class="profile-image">
                    <span class="fa fa-thumbs-o-up"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Slide 3 -->
          <div class="item">
            <div class="row">
              <div class="col-sm-6">
                <div class="single-testimonials">
                  <div class="text">
                    <p>
                      <b>Choice and Control:</b>
                      People that we support should have choice and control over
                      their own health and care services; it is they who should
                      make decisions about every aspect of their life. We aim to
                      'shift the balance of power' away from a more
                      paternalistic approach, so rather than 'doing for' we
                      strive to 'work with' the people that we support. We
                      recognise that people we support are experts in their own
                      lives. Any decisions about care and support should be in
                      line with the Mental Capacity Act. People should be
                      supported to make their own decisions and, for those who
                      lack capacity, any decision must be made in their best
                      interests involving them as much as possible and those who
                      know.
                    </p>
                  </div>

                  <div class="profile-image">
                    <span class="fa fa-thumbs-o-up"></span>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="single-testimonials">
                  <div class="text">
                    <p>
                      <b>Support and Interventions:</b>
                      Support and Interventions should always be provided in the
                      least restrictive manner. Where an individual needs to be
                      restrained in any way - either for their own protection or
                      the protection of others, restrictive interventions should
                      be for the shortest time possible and using the least
                      restrictive means possible, in line with Positive and
                      Proactive Care, and NICE guidelines.
                    </p>
                  </div>

                  <div class="profile-image">
                    <span class="fa fa-thumbs-o-up"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  mounted() {
    window.setCoreValues();
  },
};
</script>
